module.exports = __webpack_public_path__ + "img/covid-vaccination-manufacturing-surge-capacity-sars-cov-2.4cab32b0.jpg";